import { render, staticRenderFns } from "./Otp.vue?vue&type=template&id=2dbc81f6&scoped=true&"
import script from "./Otp.vue?vue&type=script&lang=ts&"
export * from "./Otp.vue?vue&type=script&lang=ts&"
import style0 from "./Otp.vue?vue&type=style&index=0&id=2dbc81f6&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2dbc81f6",
  null
  
)

export default component.exports